import matter from 'gray-matter'

import { githubCache } from '../cache'
import { GITHUB_RAW_BASE, GITHUB_REPO, resolveBranch } from '../github.const'

import { buildGithubHeaders } from './buildGithubHeaders'
import { fetchRepositoryFileRaw } from './fetchRepositoryFileRaw'
import { shouldUseGithubContentsApi } from './resolveGithubToken'

export async function fetchMarkdownFile(
  path: string,
  branch: string | null = null,
  useCache: boolean = true,
  stripFrontmatter: boolean = false,
  repo: string = GITHUB_REPO
): Promise<string> {
  const resolvedBranch = resolveBranch(branch, repo)
  const cacheKey = `${repo}:${resolvedBranch}:${path}`

  if (useCache) {
    const cached = githubCache.get(cacheKey)
    if (cached?.content) {
      return stripFrontmatter ? matter(cached.content).content.trim() : cached.content
    }
  }

  const url = `${GITHUB_RAW_BASE}/${repo}/${resolvedBranch}/${path}`

  try {
    const response = await fetch(url, {
      headers: buildGithubHeaders('text/plain'),
      cache: 'force-cache',
    })

    if (!response.ok) {
      if (shouldUseGithubContentsApi(response.status)) {
        const privateContent = await fetchRepositoryFileRaw(repo, resolvedBranch, path)
        if (privateContent) {
          githubCache.set(cacheKey, privateContent)
          return stripFrontmatter ? matter(privateContent).content.trim() : privateContent
        }
      }

      console.error(`Failed to fetch markdown file ${path}: ${response.status} ${response.statusText}`)
      return ''
    }

    const content = await response.text()
    githubCache.set(cacheKey, content, response.headers.get('etag') || undefined)

    return stripFrontmatter ? matter(content).content.trim() : content
  } catch (error) {
    console.error(`Error fetching markdown file ${path}:`, error)
    return ''
  }
}
